import React, { useEffect, useMemo, useState } from "react";
import ListCompany from "../components/company/ListCompany";
import NewCompany from "../components/company/NewCompany";
import Loader from "../components/Loader";
import ApiData from "../api/ApiData";
import { observer } from "mobx-react-lite";
import Memory from "../api/Memory";
import { Navigate } from "react-router-dom";
import RolesState from "../api/RolesState";
import stateRegion from "../state/state.region";
import User from "../api/User";
import { CcV4Root } from "../components/cc-v4";
import {
  COMPANY_LIST_SHOW_ARCHIVE_KEY,
  COMPANY_LIST_SHOW_MINE_ONLY_KEY,
  COMPANY_LIST_SUBSCRIPTION_FILTER_KEY,
  prepareCompanyList,
  readCompanyListSubscriptionFilter,
} from "../utils/companyListUtils";

const Company = observer(() => {
  const getListCountry = async () => {
    await ApiData.getListCountry();
  };
  const [visibleAddWindows, setVisibleAddWindows] = useState(false);
  const companyAddress = "новой компании";

  const [search, setSearch] = useState("");
  const [showArchive, setShowArchive] = useState(() => {
    return localStorage.getItem(COMPANY_LIST_SHOW_ARCHIVE_KEY) === "true";
  });
  const [showMineOnly, setShowMineOnly] = useState(() => {
    return localStorage.getItem(COMPANY_LIST_SHOW_MINE_ONLY_KEY) === "true";
  });
  const [subscriptionFilter, setSubscriptionFilter] = useState(() =>
    readCompanyListSubscriptionFilter(),
  );

  useEffect(() => {
    ApiData.filterDatas(search);
  }, [search]);

  const getDataFunc = async () => {
    await ApiData.getDataCompanys();
  };
  useEffect(() => {
    getListCountry();
    Memory.funcSelectDayPeriodFlag(false);
    getDataFunc();
    if (localStorage.getItem("company_region") === null) return;
    stateRegion.setParameters(
      "visibleRegion",
      JSON.parse(localStorage.getItem("company_region")),
    );
  }, []);

  const displayedCompanys = useMemo(() => {
    return prepareCompanyList(ApiData.datas ?? [], {
      partnerFilter: "clients",
      showArchive,
      showMineOnly,
      currentUserId: User.user?.id,
      subscriptionFilter,
    });
  }, [
    ApiData.datas,
    showArchive,
    showMineOnly,
    User.user?.id,
    subscriptionFilter,
  ]);

  const onShowArchiveChange = (next) => {
    setShowArchive(next);
    localStorage.setItem(COMPANY_LIST_SHOW_ARCHIVE_KEY, String(next));
  };

  const onShowMineOnlyChange = (next) => {
    setShowMineOnly(next);
    localStorage.setItem(COMPANY_LIST_SHOW_MINE_ONLY_KEY, String(next));
  };

  const onSubscriptionFilterChange = (next) => {
    setSubscriptionFilter(next);
    localStorage.setItem(COMPANY_LIST_SUBSCRIPTION_FILTER_KEY, next);
  };

  const onClickAddNew = () => {
    !visibleAddWindows
      ? setVisibleAddWindows(true)
      : setVisibleAddWindows(false);
  };

  const ClosedContainerNewCard = () => {
    setVisibleAddWindows(false);
    ApiData.updateFlagCreateCompany(false);
  };

  const cancelAdd = () => {
    setVisibleAddWindows(false);
  };

  if (RolesState.companys) {
    return (
      <CcV4Root withMainPage pageVariant="company-list-page-v4">
        {ApiData.datas !== null ? (
          <>
            <header className="card header-card company-list-page-header">
              <div className="header-top">
                <div className="company-title">
                  <div className="compamy-title-name-container">
                    <h1>Компании</h1>
                  </div>
                </div>
              </div>
            </header>
            <ListCompany
              value={search}
              setSearch={setSearch}
              companys={displayedCompanys}
              onClickAddNew={onClickAddNew}
              showArchive={showArchive}
              onShowArchiveChange={onShowArchiveChange}
              showMineOnly={showMineOnly}
              onShowMineOnlyChange={onShowMineOnlyChange}
              subscriptionFilter={subscriptionFilter}
              onSubscriptionFilterChange={onSubscriptionFilterChange}
            />

            {RolesState.company_add ? (
              <>
                {visibleAddWindows ? (
                  <NewCompany
                    onClickCancel={cancelAdd}
                    ClosedContainerNewCard={ClosedContainerNewCard}
                    companyAddress={companyAddress}
                  />
                ) : null}
              </>
            ) : null}
          </>
        ) : (
          <Loader />
        )}
      </CcV4Root>
    );
  } else {
    return <Navigate to="/noright" />;
  }
});

export { Company };
